import { render, staticRenderFns } from "./CardSocialIdentities.vue?vue&type=template&id=14f2c42b"
import script from "./CardSocialIdentities.vue?vue&type=script&lang=js"
export * from "./CardSocialIdentities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports